export const formatPrice = (number, fixed = 2, hasDollarSign = true) => {
  let fixedDecimal = `${Number.parseFloat(number).toFixed(fixed)}`;
  if (hasDollarSign) fixedDecimal = '$' + fixedDecimal;

  //https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
  // if formatting for view with $ - add a comma for thousands
  return hasDollarSign ? fixedDecimal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : fixedDecimal.toString();
};
